export default __webpack_public_path__ + "single-blog-image.jpg";